"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable import/export */
var houston_tokens_1 = tslib_1.__importDefault(require("@eduzz/houston-tokens"));
var brand_1 = require("@eduzz/houston-tokens/variables/brand");
var mediaQuery_1 = require("../mediaQuery");
var brands_1 = require("./brands");
var utils_1 = require("./utils");
var DEFAULT_PRIMARY_COLOR = '#0d2772';
function createTheme(brand, variables) {
    var _a;
    var brandColor = resolveBrandColor(brand);
    var _b = (0, houston_tokens_1.default)(brandColor.deprecated), spacingTokens = _b.spacing, tokens = tslib_1.__rest(_b, ["spacing"]);
    Object.keys(spacingTokens).forEach(function (key) {
        utils_1.spacing[key] = spacingTokens[key];
    });
    return tslib_1.__assign(tslib_1.__assign({}, tokens), { primaryColor: (_a = brandColor.antd) !== null && _a !== void 0 ? _a : DEFAULT_PRIMARY_COLOR, mediaQuery: mediaQuery_1.mediaUtils, spacing: utils_1.spacing, hexToRgba: utils_1.hexToRgba, variables: variables });
}
exports.default = createTheme;
function resolveBrandColor(brand) {
    if (typeof brand !== 'string') {
        return {
            antd: brand.primary.pure,
            deprecated: brand
        };
    }
    if (brand.startsWith('#')) {
        return {
            antd: brand,
            deprecated: {
                primary: { dark: brand, light: brand, pure: brand, medium: brand },
                secondary: { dark: brand, light: brand, pure: brand, medium: brand }
            }
        };
    }
    return {
        antd: brands_1.brandsPrimaryColor[brand],
        deprecated: brand_1.brands[brand]
    };
}
